<template>
  <div class="gauge-wrapper" style="position: relative; width: 100%; height: auto;">
    <canvas ref="gaugeCanvas" class="block"></canvas>
    <div class="needle" :style="needleStyle"></div>
    <div class="score-text">
      <div>YOUR SCORE</div>
      <div class="score">{{ score }}</div>
    </div>

    <div class="gauge-label left text-lg">0</div>
    <div class="gauge-label right text-lg">{{ maxScore }}</div>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: 'GradientGaugeChart',
  props: {
    score: { type: Number, default: 150 },
    maxScore: { type: Number, default: 200 }
  },
  computed: {
    needleStyle() {
      const percent = this.score / this.maxScore
      const deg = -90 + 180 * percent
      return {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '2px',
        height: '50%',
        background: '#f00',
        transformOrigin: 'bottom center',
        transform: `rotate(${deg}deg) translate(-50%, -100%)`
      }
    }
  },
  mounted() {
    const ctx = this.$refs.gaugeCanvas.getContext('2d')

    // 紅→綠漸層
    const gradient = ctx.createLinearGradient(0, 0, 300, 0)
    gradient.addColorStop(0, '#FF6952') // 紅
    gradient.addColorStop(1, '#EFFF0B') // 綠

    new Chart(ctx, {
      type: 'doughnut',
      data: {
        datasets: [{
          data: [this.score, this.maxScore - this.score],
          backgroundColor: [gradient, '#eee'],
          borderWidth: 0
        }]
      },
      options: {
        cutoutPercentage: 85,       // Chart.js 2.x 用法
        rotation: -Math.PI,          // 從左邊開始
        circumference: Math.PI,      // 半圓
        tooltips: { enabled: false },
        animation: { animateRotate: false },
        legend: { display: false }
      }
    })
  }
}
</script>


<style lang="scss" scoped>
.score-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 20%);
  text-align: center;
  font-weight: bold;
}
.score {
  font-size: 6.5em;
  @media (max-width: 768px) {
  font-size: 5em;
  }
}
.gauge-label {
  position: absolute;
  top: 100%;
  font-weight: bold;
}
.gauge-label.left {
  left: 2%;
  transform: translateX(-10%);
}
.gauge-label.right {
  right: 0%;
  transform: translateX(10%);
}
</style>
